import CoreSaleTooltip from './CoreSaleTooltip';
import CoreSaleTooltipContainer from './CoreSaleTooltip.container';

export default CoreSaleTooltipContainer(CoreSaleTooltip);
